import { combineReducers } from "redux";
import Setting from "./setting";
import Transaction from "./transaction";
import Customer from "./customer";
import Campaigns from "./campaigns";
import authReducer from "./authReducer";
import UploadFileData from "./uploadData";
import VoucherTemplate from "./voucher";
import BusinessGoal from "./businessGoal";

export default combineReducers({
    Setting,
    Transaction,
    Customer,
    Campaigns,
    authReducer,
    UploadFileData,
    VoucherTemplate,
    BusinessGoal
});
